




import Vue from 'vue'

export default Vue.extend({
  name: 'InputTextBox',
  props: {
    value: String,
    errorMessage: String,
    placeholder: String
  },
  computed: {
    inputText: {
      get: function () {
        return this.value
      },
      set: function (value: string) {
        this.changeValue(value)
      }
    }
  },
  methods: {
    changeValue: function (value: string) {
      this.$emit('change', value)
    }
  }
})
